import { Controller } from "@hotwired/stimulus"
import { visit } from "@hotwired/turbo"

export default class extends Controller {
  static values = { delay: Number, location: String }

  #timeout

  connect() {
    this.#timeout = setTimeout(() => {
      visit(this.locationValue)
    }, this.delayValue)
  }

  // Leaving the page through Turbo keeps its JavaScript running, and a restored page connects again.
  disconnect() {
    clearTimeout(this.#timeout)
  }
}
